import Api from "./api";

class CogenPlanApi extends Api {
	constructor(token, clientId, onUnauthorized) {
		super(token, clientId, onUnauthorized);

		this.baseUrl = this.getBaseUrl() + "co_gen_plans/";
	}

	async getCoGenStatus(taskId, onSuccess, onError) {
		this.Get(this.baseUrl + `status/?task_id=${taskId}`, onSuccess, onError);
	}

	getCoGenPlanFromDateFacility(date, facility, onSuccess, onError) {
        fetch(
            this.baseUrl +
            `?date=${date.toISOString().split('T')[0]}&facility=${facility.split("/").slice(-2)[0]}`,
            {
                method: "GET",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.getToken()
                }
            }
        ).then(
            (response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        this.onUnauthorized()
                    throw response
                }
                return response.json();
            }
        ).then(
            data => {
                if (data.length === 1) {
                    onSuccess(data[0]);
                } else if (data.length === 0) {
                    onSuccess({});
                } else {
                    throw data;
                }
            }
        ).catch(() => {
            onError();
        }
        )
    }

	async generateCoGenPlan(facility, date, onStart, onEnd, onSuccess, onError) {
		onStart();

		try {
			const response = await fetch(
				this.baseUrl +
					`generate/?facility=${facility.split("/").slice(-2)[0]}&date=${date.toISOString().split("T")[0]}`,
				{
					method: "POST",
					headers: {
						Accept: "application/json",
						"Content-Type": "application/json",
						Authorization: this.getToken(),
					},
				}
			);

			if (!response.ok) {
				if (response.status === 401) this.onUnauthorized();
				throw response;
			}

			const response_json = await response.json();

			if (response_json.status === "success") {
				onSuccess();
			} else if (response_json.status === "infeasible") {
				const message =
					"There is no feasible solution due to contradictory constraints. Please, revise constriants " +
					"for the following points:" +
					response_json.detail;
				onError(message);
			} else if (response_json.status === "error") {
				const message = "Error:" + response_json.detail;
				onError(message);
			}
		} catch (err) {
			const message = "Problem generating plan.";
			onError(message);
		}

		onEnd();
	}

	async generateAsyncCoGenPlan(
		facility,
		date,
		onStart,
		onEnd,
		onSuccess,
		onError
	) {
		onStart();

		try {
			const response = await fetch(
				this.baseUrl +
					`generate_async/?facility=${facility.split("/").slice(-2)[0]}&date=${date.toISOString().split("T")[0]}`,
				{
					method: "POST",
					headers: {
						Accept: "application/json",
						"Content-Type": "application/json",
						Authorization: this.getToken(),
					},
				}
			);

			if (!response.ok) {
				if (response.status === 401) this.onUnauthorized();
				throw response;
			}

			const response_json = await response.json();

			if (response_json.status === "enqueued") {
				return response_json.task_id;
			}
		} catch (err) {
			const message = "Problem generating plan.";
			onError(message);
		}

		onEnd();
	}

	getCoGenReport(
		facility,
		fromDate,
		toDate,
		onSuccess,
		onError,
		aggType,
		perHour
	) {
		let endPoint =
			this.baseUrl +
			`report/?facility=${facility.split("/").slice(-2)[0]}&from_date=${fromDate.toISOString().split("T")[0]}&to_date=${toDate.toISOString().split("T")[0]}`;

		if (aggType) {
			endPoint = endPoint + `&agg=${aggType}`;
		}

		if (perHour) {
			endPoint = endPoint + `&per_hour=${perHour}`;
		}

		this.Get(endPoint, onSuccess, onError);
	}

	getRealizedSavingsReport(
		facility,
		fromDate,
		toDate,
		onSuccess,
		onError,
		aggType
	) {
		let endPoint =
			this.baseUrl +
			`realized_savings_report/?facility=${facility.split("/").slice(-2)[0]}&from_date=${fromDate.toISOString().split("T")[0]}&to_date=${toDate.toISOString().split("T")[0]}`;

		if (aggType) {
			endPoint = endPoint + `&agg=${aggType}`;
		}

		this.Get(endPoint, onSuccess, onError);
	}

	getEfficiencyReport(
		facility,
		fromDate,
		toDate,
		onSuccess,
		onError,
		aggType
	) {
		let endPoint =
			this.baseUrl +
			`efficiency_report/?facility=${facility.split("/").slice(-2)[0]}&from_date=${fromDate.toISOString().split("T")[0]}&to_date=${toDate.toISOString().split("T")[0]}`;

		if (aggType) {
			endPoint = endPoint + `&agg=${aggType}`;
		}

		this.Get(endPoint, onSuccess, onError);
	}

	getCoGenReportPerGenerator(facility, fromDate, toDate, onSuccess, onError) {
		let endPoint =
			this.baseUrl +
			`report_per_generator/?facility=${facility.split("/").slice(-2)[0]}&from_date=${fromDate.toISOString().split("T")[0]}&to_date=${toDate.toISOString().split("T")[0]}`;

		this.Get(endPoint, onSuccess, onError);
	}
}

export default CogenPlanApi;
